jQuery(function () {

    /*
    Whole Wrapper
    #external-map-wrapper-{contentObject.uid}
    .external-map-wrapper

    Search Wrapper
    #search-wrapper-{contentObject.uid}
    .search-wrapper

    Search Results
    .search-results

    Map Wrapper
    .map-wrapper .ppcarto-airbnb
    or
    .map-wrapper .ppcarto-static

    .airbnb-change-view-buttons button.changeView
    */

    window.forDebugging = false;

    /**
     * the geojson data of the loaded list
     * @type {Array}
     */
    var geojsonData = [];

    var sessionRequestUrl = window.pixelpoint.utilities.getAjaxUrl(`/index.php?action=sessionFilters&type=1732176051`);

    var mapFunctions = {
        mapObject($wrapper) {
            var staticWrapper = $wrapper.find(".ppcarto-static");
            var map = staticWrapper.data("ppcarto-static") || null;
            if (!!map && !!map.$refs && !!map.$refs.static)
                return map.$refs.static;
            if (staticWrapper.length == 0) {
                staticWrapper = $wrapper.find(".ppcarto-airbnb");
                map = staticWrapper.data("ppcarto-airbnb") || null;
                if (!!map && !!map.$refs && !!map.$refs.airbnb)
                    return map.$refs.airbnb;
            }
            return null;
        },
        getMapType() {
            return "static";
        },
        removeBBox($wrapper) {
            var mapObject = mapFunctions.mapObject($wrapper);
            if (!!mapObject.filter && !!mapObject.filter.bbox) {
                delete mapObject.filter.bbox;
            }
        },
        reloadData($wrapper) {
            var mapObject = mapFunctions.mapObject($wrapper);
            if (!!mapObject) {
                mapObject.init = true;
                mapObject.getData();
            }
        },
        isSearchOnMoveActive($wrapper) {
            var mapObject = mapFunctions.mapObject($wrapper);
            return mapObject.triggerSearchOnMove || false;
        },
        isSearchSupressed($wrapper) {
            var mapObject = mapFunctions.mapObject($wrapper);
            return mapObject.supressSearch || false;
        },
        changeBBox(bbox) {
            if (!bbox)
                return bbox;
            let splittedBox = bbox.split(",");
            if (splittedBox.length >= 4) {

                if (parseFloat(splittedBox[0]) > parseFloat(splittedBox[1])) {
                    let tmp = splittedBox[0];
                    splittedBox[0] = splittedBox[1];
                    splittedBox[1] = tmp;
                }
                if (parseFloat(splittedBox[2]) > parseFloat(splittedBox[3])) {
                    let tmp = splittedBox[2];
                    splittedBox[2] = splittedBox[3];
                    splittedBox[3] = tmp;
                }

                // we switch the 2nd and 4th coordinate
                if (parseFloat(splittedBox[1]) > parseFloat(splittedBox[3])) {
                    let tmp = splittedBox[1];
                    splittedBox[1] = splittedBox[3];
                    splittedBox[3] = tmp;
                }
                //end

                bbox = splittedBox.join(",");
            }
            return bbox;
        },
        getBBox($wrapper) {
            var mapObject = mapFunctions.mapObject($wrapper);
            let bbox = '0,0,0,0';
            if (mapObject && mapObject.bbox) {
                bbox = mapObject.bbox();
                bbox = mapFunctions.changeBBox(bbox);
            }
            return bbox;
        }
    };

    var privateFunctions = {
        collectPoiData($html = null) {
            geojsonData = [];
            var $elements = null;
            if ($html == null) {
                $elements = wrapper.find("[data-geojson]");
            } else {
                $elements = $html.find("[data-geojson]");
            }
            $elements.each(function () {
                var geojson = $(this).data('geojson');
                if (!!geojson) {
                    geojsonData.push(geojson);
                }
            });
        },
        switchToDefaultView($wrapper) {
            var switchToMap = $wrapper.find(".show-map-wrapper .switch-to-map");

            if (switchToMap.length == 0)
                return;
            var id = switchToMap.data('switch-trigger');
            if (!id)
                return;
            window.pixelpoint.pubSub.publish(window.pixelpoint.pubSub.events.switchSetDefault + ":" + id);
        },
        addBBox(data, bbox) {
            if (!bbox)
                return data;
            if (!bbox[0] || !bbox[0][0] || !bbox[0][1] || !bbox[1] || !bbox[1][0] || !bbox[1][1])
                return data; //bbox malformed
            for (var i = 0; i < 2; i++) {
                for (var j = 0; j < 2; j++) {
                    var obj = {
                        'name': `filters[bbox][${i}][${j}]`,
                        'value': bbox[i][j]
                    }
                    data.push(obj);
                }
            }

            return data;
        },
        loadSessionFilters(sessionFiltersDeferred, cid) {
            if (!sessionFiltersDeferred) {
                sessionFiltersDeferred = $.Deferred(function (defer) {
                    $.ajax(sessionRequestUrl, {
                        method: "POST",
                        data: JSON.stringify({
                            keys: ['AirBnB', cid],
                            url: window.location.href
                        }),
                        contentType: "application/json; charset=utf-8"
                    }).done(function (data, textStatus, request) {
                        defer.resolve(data);
                    }).fail(defer.reject).always(defer.always);
                }).promise();
            }
            return sessionFiltersDeferred;
        },
        getStickyElementHeight($blogHeader, outer) {
            if (typeof outer === 'undefined') {
                outer = true;
            }
            var addAnchored = false;
            var removeIsStuck = false;
            if ($blogHeader.hasClass("is-anchored")) {
                $blogHeader.removeClass("is-anchored");
                addAnchored = true;
            }
            if (!$blogHeader.hasClass("is-stuck")) {
                $blogHeader.addClass("is-stuck");
                removeIsStuck = true;
            }

            var result = 0;
            if (!!outer) {
                result = $blogHeader.outerHeight();
            } else {
                result = $blogHeader.height();
            }
            if (addAnchored) {
                $blogHeader.addClass("is-anchored");
            }
            if (removeIsStuck) {
                $blogHeader.removeClass("is-stuck");
            }
            return result;
        },
        getHeaderHeight($wrapper, outer) {
            if (typeof outer === 'undefined') {
                outer = true;
            }

            var result = 0;
            var $blogHeader = $wrapper.closest("#blog-days-container").find("#blogHeader .day-section .row.sticky");
            var $blogHeaderStuck = $wrapper.closest("#blog-days-container").find("#blogHeader .day-section .row.sticky.is-stuck");

            if (!!outer) {
                if (!!$wrapper && $blogHeaderStuck.length > 0) {
                    result = $(".header-wrapper .header").outerHeight() + $blogHeaderStuck.outerHeight();
                } else if (!!$wrapper && $blogHeader.length > 0) {
                    result = $(".header-wrapper .header").outerHeight() + privateFunctions.getStickyElementHeight($blogHeader, true);
                }
            } else {
                if (!!$wrapper && $blogHeaderStuck.length > 0) {
                    result = $(".header-wrapper .header").height() + $blogHeaderStuck.height();
                } else if (!!$wrapper && $blogHeader.length > 0) {
                    result = $(".header-wrapper .header").height() + privateFunctions.getStickyElementHeight($blogHeader, false);
                }
            }
            return result;
        },
        getRealWindowHeight($wrapper) {
            return $(window).height() - privateFunctions.getHeaderHeight($wrapper);
        },
        getRealScrollPosition(scrollPosition, $wrapper) {
            var bottomModulePosition = $wrapper.offset().top + $wrapper.height();
            if ((bottomModulePosition - scrollPosition) < privateFunctions.getRealWindowHeight($wrapper)) {
                return bottomModulePosition - $(window).height();
            }
            return scrollPosition;
        },
        clearDefaultTextValue($wrapper) {
            //clears the default text value. Since the preset text value must not be visible, we have to set it each time. This function
            //the default text value. It is called on clicko on the button
            var input = $wrapper.find("input[name='filters[q]']");
            if (!input.data('saved-default-value'))
                input.data('saved-default-value', input.data('default-value'));
            input.data('default-value', '');
        },
        restoreDefaultValue($wrapper) {
            var input = $wrapper.find("input[name='filters[q]']");
            if (!!input.data('saved-default-value'))
                input.data('default-value', input.data('saved-default-value'));
        },
        setDefaultValue(data, $wrapper) {
            //sets the default value since we need to use it in some cases (if the map moves for example)
            var defaultValue = $wrapper.find("input[name='filters[q]']").data('default-value');
            if (!!defaultValue) {
                $.each(data, function (index, element) {
                    if (element.name == "filters[q]") {
                        element.value = defaultValue
                    }
                });
            }
            return data;
        },
        moveToElement(data) {
            var id = data.id || 0;
            if (!id) {
                return;
            }

            var searchResultItem = $(`.search-result-item[data-id='${id}']`); //that's ok

            if (searchResultItem.length == 0) {
                return searchResultItem;
            }

            var headerHeight = $(".header-wrapper .header").height() || 0;
            var offset = searchResultItem.offset();
            var topOffset = offset.top;
            var bottomOffset = offset.top + searchResultItem.height();

            if (topOffset < ($(window).scrollTop() + headerHeight) || bottomOffset > ($(window).scrollTop() + $(window).height())) {
                // Not in view so scroll to it
                var scrollPosition = (topOffset - headerHeight) - 10;
                scrollPosition = privateFunctions.getRealScrollPosition(scrollPosition);
                $('html,body').animate({
                    scrollTop: scrollPosition
                }, 500);
            }

            return searchResultItem;
        },
        afterAllImagesLoaded($container) {
            var d = $.Deferred();
            var imgs = $container.find("img");
            imgs.one("load.allimages error.allimages", function () {
                imgs = imgs.not(this);
                if (imgs.length == 0) {
                    d.resolve();
                }
            });
            var complete = imgs.filter(function () {
                return this.complete;
            });
            complete.off(".allimages");
            imgs = imgs.not(complete);
            complete = undefined;
            if (imgs.length == 0) {
                d.resolve();
            }
            return d.promise();
        },
        setResultItemHeight($wrapper) {
            var equalHeighElem = $wrapper.find(".search-wrapper .search-result-item");

            setTimeout(function () {
                equalHeight(equalHeighElem, true);
                initStickyMapElements($wrapper);
            }, 300)
        },
        validateForm(displayErrors, form) {
            displayErrors = displayErrors || false;
            form.find(".invalid").removeClass("invalid");
            var valid = true;

            var visitorPicker = form.find(".visitor-picker");
            if (visitorPicker.length > 0) {
                var formFunctions = visitorPicker.data("form-element-functions");
                if (!!formFunctions.get) {
                    var visitors = formFunctions.get();
                    if (!!visitors.kids && visitors.kids > 0) {
                        if (visitorPicker.is("[data-to-disable]")) {
                            var von = form.find(".calendar input.von").val();
                            var bis = form.find(".calendar input.bis").val();
                            if (!von || !bis) {
                                valid = false;
                                if (displayErrors) {
                                    form.find(".calendar").closest(".element-wrapper").addClass("invalid");
                                }
                            }
                        }
                    }
                }
                if (!!formFunctions.valid) {
                    if (!formFunctions.valid(true)) {
                        valid = false;
                    }
                }
            }

            return valid;
        },
        generateFormAction(url, bbox, switchValue, $wrapper) {
            var cid = $wrapper.data("cid");
            var pid = $wrapper.data("pid");

            if (!cid || !pid) {
                return url;
            }

            bbox = bbox || null;
            switchValue = switchValue || null;

            var domainReloadParameters = window.pixelpoint.utilities.getSysPageUrl();
            var parsed = window.pixelpoint.utilities.parseUrl(url);
            parsed.baseUrl = domainReloadParameters.baseUrl;//window.location.origin;
            if(domainReloadParameters.useAjaxRenderPageId)
                parsed.queryParameters['id'] = domainReloadParameters.ajaxRenderPageId;
            //parsed.queryParameters.id = window.pixelpoint.domainService.get("ajaxRenderPage");//1568;
            parsed.queryParameters.cid = cid;
            parsed.queryParameters.pid = pid;
            parsed.queryParameters.no_cache = 1;

            if (!!switchValue) {
                parsed.queryParameters.switchValue = switchValue;
            } else {
                if ($wrapper.find('[name="switchValue"]').length > 0) {
                    parsed.queryParameters.switchValue = $wrapper.find('[name="switchValue"]').val();
                }
            }

            if (!!parsed.queryParameters.cHash) {
                delete parsed.queryParameters.cHash;
            }

            if (!!bbox) {
                if ($.isArray(bbox))
                    bbox = bbox.join();
                parsed.queryParameters.bbox = bbox;
            }

            return window.pixelpoint.utilities.buildUrl(parsed);
        },
        submitForm(callback, $wrapper) {
            var form = $wrapper.find(".search > .filters-container form");
            var loaderFunctions = $wrapper.find(".search-results .loader[data-loader]").data("exposed");
            if (form.length == 0) return;
            var url = form.attr('action');

            if (!url) {
                url = window.location.href;
            }

            var switchToMap = $wrapper.find(".show-map-wrapper .switch-to-map");
            if (switchToMap.length > 0) {
                var currentValue = switchToMap.data('selected-value') || switchToMap.data('initial-value');
                url = privateFunctions.generateFormAction(url, null, currentValue, $wrapper);
            } else {
                url = privateFunctions.generateFormAction(url, null, null, $wrapper);
            }

            var method = form.attr('method');
            if (!!loaderFunctions) {
                loaderFunctions.show();
            }

            var bbox = $wrapper.ppcommon("boundingBox");
            bbox = mapFunctions.changeBBox(bbox);
            var selectedRegionId = null;
            var selectedRegionType = "";
            //var zoomToCoordinates = []; //@deprecated

            privateFunctions.clearRegionFromAirBnB($wrapper);

            var data = form.serializeArray();
            $.each(data, function (index, element) {

                // we get the first selected region (if there is any)
                if (selectedRegionId == null) {
                    if (element.name == 'filters[locationTree][]') {
                        if (element.value.indexOf(":region") > -1) {
                            let splitted = element.value.split(":");
                            selectedRegionId = splitted[0];
                            selectedRegionType = 'region';
                        } else if (element.value.indexOf(":aqua") > -1) {
                            let splitted = element.value.split(":");
                            selectedRegionId = splitted[0];
                            selectedRegionType = 'aquaticsdistrict';
                        } else if (element.value.indexOf(":national") > -1) {
                            let splitted = element.value.split(":");
                            selectedRegionId = splitted[0];
                            selectedRegionType = 'nationallandscape';
                        } else if (element.value.indexOf(":excursion") > -1) {
                            let splitted = element.value.split(":");
                            selectedRegionId = splitted[0];
                            selectedRegionType = 'excursion';
                        }
                    }
                }

                if (element.name == 'filters[q]') {
                    if (!element.value) {
                        var defaultData = $wrapper.find(`[name='filters[q]']`).data('default-value');
                        if (!!defaultData)
                            element.value = defaultData;
                    }
                }
            });

            //set the default value, if it exists
            data = privateFunctions.setDefaultValue(data, $wrapper);

            //add the geojson data, if existing
            if (!!bbox && $.isArray(bbox)) {
                data = privateFunctions.addBBox(data, bbox);
            } else if (!!bbox && $.type(bbox) === "string") {
                data.push({
                    name: "filters[bbox]",
                    value: bbox
                })
            }
            var dataToSend = $.param(data);

            if (!!$wrapper.ppcommon("ajaxRequest")) {
                $wrapper.ppcommon("ajaxRequest").abort();
            }
            form.find(".groups").hide();
            var searchResultsContainer = $wrapper.find(".search-results .inner-wrapper");
            var cid = $wrapper.data("cid");
            var ajaxRequest = $.ajax({
                type: method,
                url: url,
                data: data,
                success: function (data) {
                    var results = $(data).find(`[data-cid='${cid}'] .search-results .inner-wrapper`).html();
                    if (!results) results = '';
                    searchResultsContainer.html(results);

                    //privateFunctions.initializeSliders();
                    window.pixelpoint.tooltip.init(searchResultsContainer.find('.ttip-blue'));
                    window.pixelpoint.initOpeningHoursText();

                    $wrapper.find('.map-wrapper.sticky').foundation('_calc', true);

                    if (!!loaderFunctions) {
                        privateFunctions.afterAllImagesLoaded(searchResultsContainer).then(function () {
                            privateFunctions.setResultItemHeight($wrapper);
                            loaderFunctions.hide();
                        });
                    }

                    var itemCount = $wrapper.find(".result-list .search-result-item").length;
                    if (!$wrapper.ppcommon("supressSliding")) {
                        if (itemCount > 0) {
                            let scrollPosition = $wrapper.find(".search-results").offset().top - $wrapper.find(".header-wrapper .header").height();
                            scrollPosition = privateFunctions.getRealScrollPosition(scrollPosition, $wrapper);
                            $('html, body').animate({
                                scrollTop: scrollPosition
                            }, 500);
                        } else {
                            let scrollPosition = $wrapper.find(".filters-container").offset().top - $wrapper.find(".header-wrapper .header").height();
                            scrollPosition = privateFunctions.getRealScrollPosition(scrollPosition, $wrapper);
                            $('html, body').animate({
                                scrollTop: scrollPosition
                            }, 500);
                        }
                    } else {
                        $wrapper.ppcommon("supressSliding", false);
                    }

                    if (!$wrapper.ppcommon("supressMapUpdate") && !!privateFunctions.isAirBnB($wrapper)) {
                        $wrapper.ppcommon("ignoreAirBnBEvent", true);

                        //because sometimes the map does not trigger the event after moving (have to find out the reason yet),
                        //we have to make sure, the "ignoreAirBnBEvent" variable is set to false after a period of time
                        setTimeout(function () {
                            $wrapper.ppcommon("ignoreAirBnBEvent", false);
                        }, 2000);

                        //privateFunctions.filtersToAirBnB($wrapper);
                        privateFunctions.dataToAirBnB($wrapper);
                        privateFunctions.calculateOffset($wrapper);
                    } else {
                        $wrapper.ppcommon("supressMapUpdate", false);
                    }

                    if (selectedRegionId != null) {
                        privateFunctions.regionToAirBnB(selectedRegionId, selectedRegionType, $wrapper);
                    }

                    $wrapper.ppcommon("ajaxRequest", null);

                    // do everything for mobile
                    if ($wrapper.ppcommon('isAirBnbOrExternalMap') && $wrapper.find('.airbnb-change-view-buttons').is(':visible')) {
                        followingElementsInContainer($wrapper.find('.airbnb-change-view-buttons'), $wrapper.find('.search-results'));
                    }

                    if (!!callback)
                        callback();
                }
            });
            $wrapper.ppcommon("ajaxRequest", ajaxRequest)
        },
        clearRegionFromAirBnB($wrapper) {
            var airBnB = mapFunctions.mapObject($wrapper);
            if (!airBnB || !airBnB.clearRegion)
                return;
            airBnB.clearRegion();
        },
        regionToAirBnB(id, type, $wrapper) {
            if (!id)
                return;
            type = type || 'region';
            var airBnB = mapFunctions.mapObject($wrapper);
            if (!airBnB)
                return;
            airBnB.setRegion({
                type: type,
                id: window.pixelpoint.utilities.getMapRegion(id)//id
            });
        },
        filtersToAirBnB($wrapper) {
            var airBnB = mapFunctions.mapObject($wrapper);
            if (!airBnB)
                return;
            var searchResultsContainer = $wrapper.find(".search-results .inner-wrapper");
            var resultListWrapper = searchResultsContainer.find(".result-list-wrapper");
            if (resultListWrapper.length > 0) {
                var filters = resultListWrapper.data("jsonFilters");
                if (!!filters) {
                    var type = resultListWrapper.data("jsonEndpoint");
                    if (!type)
                        type = "poi";

                    if (!!$wrapper.ppcommon("changeMapSection")) {
                        airBnB.init = true;
                        airBnB.zoom = null;
                        airBnB.coordinates = [];
                        $wrapper.ppcommon("changeMapSection", false);
                    }
                    airBnB.type = type;
                    airBnB.filter = filters;

                    /*
                     privateFunctions.mapObject().$nextTick(function () {
                     airBnB.init = false;
                     airBnB.$nextTick(function () {
                     if (!!changeMapSection) {
                     airBnB.init = true;
                     changeMapSection = false;
                     }
                     airBnB.type = type;
                     airBnB.filter = filters;
                     });
                     });
                     //*/
                }
            }
        },
        dataToAirBnB($wrapper) {
            var airBnB = mapFunctions.mapObject($wrapper);
            if (!airBnB)
                return;
            privateFunctions.collectPoiData($wrapper);
            var type = $wrapper.find(".result-list-wrapper").data("jsonEndpoint");
            if (!type)
                type = "poi";
            //if (!!changeMapSection) {
            airBnB.init = true;
            airBnB.zoom = null;
            airBnB.coordinates = [];
            //    changeMapSection = false;
            //}
            airBnB.type = type;
            airBnB.geojson = {
                "type": "FeatureCollection",
                "features": geojsonData
            };
        },
        calculateOffset($wrapper) {
            var airBnB = mapFunctions.mapObject($wrapper);
            if (!airBnB)
                return;
            if (!$wrapper.find(".rbnb-wrapper").is(".fullsize")) {
                airBnB.offset = 0;
                return;
            }

            if ($wrapper.find('.airbnb-change-view-buttons').is(':visible')) {
                airBnB.offset = 0;
                return;
            }

            var searchContainer = $wrapper.find(".rbnb-wrapper .search");

            if (searchContainer.length == 0)
                return;
            var offset = searchContainer.offset().left + searchContainer.outerWidth();

            if (searchContainer.hasClass("switch-big")) {
                offset = offset / 2;
            }

            airBnB.offset = offset;
        },
        initialSetBBox($wrapper, sessionFiltersDeferred) {
            var mapWrapper = $wrapper.find(".map-internal-wrapper");

            privateFunctions.calculateOffset($wrapper);

            var zoom = mapWrapper.data("initial-zoom");
            var longitude = mapWrapper.data("initial-longitude");
            var latitude = mapWrapper.data("initial-latitude");

            var reloadModule = function () {
                if (!!privateFunctions.isAirBnB($wrapper)) {
                    //privateFunctions.filtersToAirBnB(); //@deprecated
                    var requestType = $wrapper.data('request');
                    if (requestType == 'GET') {
                        $wrapper.ppcommon("supressMapUpdate", false);
                        privateFunctions.reloadModule(null, null, false, null, $wrapper);
                    } else
                        //privateFunctions.filtersToAirBnB($wrapper);
                        privateFunctions.dataToAirBnB($wrapper);
                } else {
                    privateFunctions.reloadModule(null, null, false, null, $wrapper);
                }
            }

            if (zoom > 0 || (longitude > 0 && latitude > 0)) {

                sessionFiltersDeferred.done(function (data) {
                    if (!data) {
                        //-----------------------------------
                        var viewArguments = {};
                        if (zoom > 0)
                            viewArguments.zoom = zoom;
                        if (longitude > 0 && latitude > 0)
                            viewArguments.coordinates = [latitude, longitude];

                        if (!!privateFunctions.isAirBnB($wrapper)) {
                            mapFunctions.mapObject($wrapper).$once("moveend", function () {
                                var bbox = mapFunctions.getBBox($wrapper);//mapFunctions.mapObject($wrapper).bbox();

                                $wrapper.ppcommon("boundingBox", bbox);
                                $wrapper.ppcommon("supressMapUpdate", true);
                                var requestType = $wrapper.data('request');
                                /* //@deprecated
                                 privateFunctions.filtersToAirBnB();
                                 privateFunctions.submitForm();
                                 //*/
                                if (requestType == 'POST') {
                                    privateFunctions.submitForm(null, $wrapper);
                                } else {
                                    $wrapper.ppcommon("supressMapUpdate", false);
                                    privateFunctions.reloadModule(bbox, null, true, null, $wrapper);
                                }
                            });
                        }
                        if (!!privateFunctions.isAirBnB($wrapper)) {
                            mapFunctions.mapObject($wrapper).$nextTick(function () {
                                mapFunctions.mapObject($wrapper).init = false;
                                mapFunctions.mapObject($wrapper).changeView(viewArguments);
                            });
                        } else {
                            reloadModule(null, null, false, null, $wrapper);
                        }
                        //-----------------------------------
                    } else {
                        reloadModule(null, null, false, null, $wrapper);
                    }
                });
            } else {
                reloadModule(null, null, false, null, $wrapper);
            }
        },
        switchFilters(filtersHtml, $wrapper) {
            if (!filtersHtml)
                return;
            var filtersContainer = $wrapper.find(".search > .filters-container");
            if (!filtersContainer || filtersContainer.length == 0)
                return;
            var filterForm = filtersContainer.find('.filter-form');
            filterForm.html("");
            filterForm.append($(filtersHtml));

            filterForm.find(".calendar").each(function () {
                window.pixelpoint.ppComponents.calendar($(this));
            });
            filterForm.find(".visitor-picker").each(function () {
                window.pixelpoint.ppComponents.visitorPicker($(this));
            });
            filterForm.find("[data-quick-clear]").each(function () {
                window.pixelpoint.ppComponents.quickClear($(this));
            });
            filterForm.find(".belegung-component").each(function () {
                window.pixelpoint.ppComponents.belegung($(this));
            });
            filterForm.find("[data-disabler]").each(function () {
                window.pixelpoint.ppComponents.disabler($(this));
            });


            var marginInPx = privateFunctions.getHeaderHeight($wrapper, false); //$('.header-wrapper .header').height();

            // scroll effect on Large Screens
            if (Foundation.MediaQuery.current == "large") {
                //var marginInPxNew = $('.header-wrapper .header .main-nav').height() + 12;
                var marginInPxNew = $('.header-wrapper .header .main-nav').height() - 2;
                marginInPx = marginInPxNew;
            }
            // scroll effect on Large Screens - END

            var marginInEm = marginInPx / parseFloat($("body").css("font-size"));

            if (filterForm.find("[data-order-by]").length > 0) {
                setTimeout(function () {
                    var sticky = new Foundation.Sticky(filterForm.find("[data-order-by]"), {
                        topAnchor: 'orderbywrapper:top',
                        btmAnchor: 'rbnb-wrapper-id:bottom',
                        marginTop: marginInEm
                    });
                    $(window).trigger("load.zf.sticky");
                }, 50);
                filterForm.find("[data-order-by]").each(function () {
                    window.pixelpoint.ppComponents.orderBy($(this));
                });
            } else {
                if (filterForm.find(".order-by").length > 0) {
                    setTimeout(function () {
                        var sticky = new Foundation.Sticky(filterForm.find(".order-by"), {
                            topAnchor: 'orderbywrapper:top',
                            btmAnchor: 'rbnb-wrapper-id:bottom',
                            marginTop: marginInEm
                        });
                        $(window).trigger("load.zf.sticky");
                    }, 50);
                }
            }
            window.ppComponents.common.sliders(filterForm.find(".range-slider"));
            window.ppComponents.select2.initialize(filterForm.find('.select2'));
            window.ppComponents.select2.initializeRemote(filterForm.find("select.autocomplete"));

            filterForm.find("[data-group-selector]").each(function () {
                window.pixelpoint.ppComponents.groupExtension($(this));
            });
            filterForm.find(".loader[data-loader]").each(function () {
                window.pixelpoint.ppComponents.loader($(this));
            });
            window.ppComponents.common.showMore(filterForm.find(".more-wrapper"));
            privateFunctions.checkAndHideExpandButton($wrapper);
        },
        reloadModule(boundingBox, callback, keepMapSection, switchValue, $wrapper) {
            if ($wrapper.find(".map-internal-wrapper").data('supress-module-reload'))
                return;

            switchValue = switchValue || null;
            var loaderFunctions = $wrapper.find(".search-results .loader[data-loader]").data("exposed");
            var url = privateFunctions.generateFormAction(window.location.href, boundingBox, switchValue, $wrapper);
            keepMapSection = keepMapSection || false;
            if (!!loaderFunctions) {
                loaderFunctions.show();
            }
            var searchResultsContainer = $wrapper.find(".search-results .inner-wrapper");
            var cid = $wrapper.data("cid");
            var pid = $wrapper.data("pid");
            var ajaxRequest = $.ajax({
                type: 'GET',
                url: url,
                success: function (data) {
                    var results = $(data).find(`[data-cid='${cid}'] .search-results .inner-wrapper`).html();
                    var filtersHtml = $(data).find(`[data-cid='${cid}'] .search > .filters-container .filter-form`).html();
                    if (!results) results = '';
                    searchResultsContainer.html(results);

                    if (!!privateFunctions.isAirBnB($wrapper)) {
                        if (!filtersHtml)
                            filtersHtml = '';
                        privateFunctions.switchFilters(filtersHtml, $wrapper);
                    }

                    //privateFunctions.initializeSliders();
                    window.pixelpoint.tooltip.init(searchResultsContainer.find('.ttip-blue'));
                    window.pixelpoint.initOpeningHoursText();
                    window.pixelpoint.images.initializeErrors(searchResultsContainer);
                    //$wrapper.find('.map-wrapper.sticky').foundation('_calc', true);

                    privateFunctions.afterAllImagesLoaded(searchResultsContainer).then(function () {
                        privateFunctions.setResultItemHeight($wrapper);
                        if (!!loaderFunctions) {
                            loaderFunctions.hide();
                        }
                    });
                    var itemCount = $wrapper.find(".result-list .search-result-item").length;
                    if (!$wrapper.ppcommon("supressSliding")) {
                        if (itemCount > 0) {
                            let scrollPosition = $wrapper.find(".search-results").offset().top - $(".header-wrapper .header").height();
                            scrollPosition = privateFunctions.getRealScrollPosition(scrollPosition, $wrapper);
                            $('html, body').animate({
                                scrollTop: scrollPosition
                            }, 500);
                        } else {
                            let scrollPosition = $wrapper.find(".filters-container").offset().top - $(".header-wrapper .header").height();
                            scrollPosition = privateFunctions.getRealScrollPosition(scrollPosition, $wrapper);
                            $('html, body').animate({
                                scrollTop: scrollPosition
                            }, 500);
                        }
                    } else {
                        $wrapper.ppcommon("supressSliding", false);
                    }

                    if (!$wrapper.ppcommon("supressMapUpdate") && !!privateFunctions.isAirBnB($wrapper)) {
                        $wrapper.ppcommon("ignoreAirBnBEvent", true);

                        if (!keepMapSection)
                            $wrapper.ppcommon("changeMapSection", true); // if reloading the module, we always change the map section

                        //because sometimes the map does not trigger the event after moving (have to find out the reason yet),
                        //we have to make sure, the "ignoreAirBnBEvent" variable is set to false after a period of time
                        setTimeout(function () {
                            $wrapper.ppcommon("ignoreAirBnBEvent", false);
                        }, 2000);

                        //privateFunctions.filtersToAirBnB($wrapper);
                        privateFunctions.dataToAirBnB($wrapper);
                        privateFunctions.calculateOffset($wrapper);
                    } else {
                        $wrapper.ppcommon("supressMapUpdate", false);
                    }

                    $wrapper.ppcommon("ajaxRequest", null);

                    // do everything for mobile
                    if ($wrapper.ppcommon('isAirBnbOrExternalMap') && $wrapper.find('.airbnb-change-view-buttons').is(':visible')) {
                        followingElementsInContainer($wrapper.find('.airbnb-change-view-buttons'), $wrapper.find('.search-results'));
                    }

                    if (!!callback)
                        callback();
                }
            });
            $wrapper.ppcommon("ajaxRequest", ajaxRequest);
        },

        /**
         * The below function has to be completely rewritten or omitted, sinde it will be dificult to scroll to a module if there are several on the site
         *
         */

        scrollToModule() {
            //scrolls to the module if, and only if, it was a click back from a detail site
            var currentPage = window.location.href;
            var key = `airBnBKeepPositionOnBack:${currentPage}`;
            //var key2 = `airBnBKeepPosition`;
            var keepPositionOnBack = window.sessionStorage.getItem(key);
            //var keepPosition = window.sessionStorage.getItem(key2);
            if (!!keepPositionOnBack) {
                if (window.pixelpoint.history.visitorCameBack()) {
                    window.sessionStorage.removeItem(key);
                    //window.sessionStorage.removeItem(key2);
                    window.pixelpoint.utilities.scrollTo($(".search-results"), false, 0, true);
                }
            }
        },
        collectFormData(formName, $wrapper) {
            formName = formName || 'poi';
            //collecting form data for tag manager
            var categoryInput = $wrapper.find(".rbnb-wrapper [name='filters[categories][]']");
            var tagInput = $wrapper.find(".rbnb-wrapper select[name='filters[categories][0][tags][]']");
            var locationTreeInput = $wrapper.find(".rbnb-wrapper [name='filters[locationTree][]']");

            var result = {
                "Regionen": null,
                "Orte": null,
                "nationale Naturlandschaften": null,
                "Ausflugsregionen": null,
                "Wassersportreviere": null,
                "Kategorien": null,
                "Unterkunftsarten": null
            };

            var nameMap = {
                'region': 'Regionen',
                'location': 'Orte',
                'aqua': 'Wassersportreviere',
                'national': 'nationale Naturlandschaften',
                'excursion': 'Ausflugsregionen'
            };

            //******* first the categories */
            var selections = null;
            var key = null;
            if (tagInput.length == 0) {
                if (categoryInput.length > 0) {
                    selections = categoryInput.val();
                }
                if (!selections) {
                    var groups = $wrapper.find(".groups-outer-wrapper .groups section[data-group-id]");
                    if (groups.length > 0) {
                        selections = [];
                        groups.each(function () {
                            var categoryInput = $(this).find("input[type='hidden'][name^='filters[categories]']").filter("[name$='[category]']");
                            if (categoryInput.length > 0) {
                                var categoryValue = categoryInput.val();
                                selections.push(categoryValue);
                            }
                        });
                    }
                }

                if (!!selections) {
                    key = 'Kategorien';
                    if (formName == 'accomodation')
                        key = 'Unterkunftsarten';

                    if (!result[key])
                        result[key] = [];

                    $.each(selections, function (i, selection) {
                        var parts = selection.split(":");
                        if (!!parts) {
                            if (parts.length > 1) {
                                result[key].push(parts[1]);
                            } else {
                                result[key].push(parts[0]);
                            }
                        }
                    });
                }
            }
            //**********then the tags */
            selections = null;
            if (tagInput.length > 0) {
                if (tagInput.hasClass("select2-hidden-accessible"))
                    selections = tagInput.select2('data').map(function (x) {
                        return `${x.id}:${x.text}`;
                    });
                else
                    selections = tagInput.val();
            }
            if (!!selections) {
                key = 'Kategorien';
                if (formName == 'accomodation')
                    key = 'Unterkunftsarten';

                if (!result[key])
                    result[key] = [];

                $.each(selections, function (i, selection) {
                    var parts = selection.split(":");
                    if (!!parts) {
                        if (parts.length > 1) {
                            result[key].push(parts[1]);
                        } else {
                            result[key].push(parts[0]);
                        }
                    }
                });
            }

            if (locationTreeInput.length > 0) {
                selections = locationTreeInput.val();
                if (!!selections) {
                    if (!$.isArray(selections))
                        selections = [selections];
                    $.each(selections, function (i, selection) {
                        var parts = selection.split(':');
                        if (parts.length >= 3) {
                            var locationType = nameMap[parts[2]] || null;
                            if (!!locationType) {
                                if (!result[locationType])
                                    result[locationType] = [];
                                result[locationType].push(parts[1]);
                            }
                        }
                    });
                }
            }
            return {
                "Regionen": (result.Regionen != null) ? result.Regionen.join(',') : null,
                "Orte": (result.Orte != null) ? result.Orte.join(',') : null,
                "nationale Naturlandschaften": (result['nationale Naturlandschaften'] != null) ? result['nationale Naturlandschaften'].join(',') : null,
                "Ausflugsregionen": (result.Ausflugsregionen != null) ? result.Ausflugsregionen.join(',') : null,
                "Wassersportreviere": (result.Wassersportreviere != null) ? result.Wassersportreviere.join(',') : null,
                "Kategorien": (result.Kategorien != null) ? result.Kategorien.join(',') : null,
                "Unterkunftsarten": (result.Unterkunftsarten != null) ? result.Unterkunftsarten.join(',') : null,
            };
        },

        checkAndHideExpandButton($wrapper) {
            $wrapper.find(".filter-form").each((index, filterForm) => {
                let $filterForm = $(filterForm);
                let expandButton = $filterForm.find(".subtitle-aufklapbar");
                let fineFilters = $filterForm.find(".fine-search");
                let collapsed = fineFilters.hasClass("collapsed");
                fineFilters.removeClass("collapsed");
                if (fineFilters.height() == 0) {
                    expandButton.hide();
                } else {
                    expandButton.show();
                }
                if (!!collapsed)
                    fineFilters.addClass("collapsed");
            });
        },
        isAirBnB($wrapper) {
            return ($wrapper.data("filters-used") == 1) ? true : false;
        }
    };

    window.externalMap = window.externalMap || {};
    window.externalMap.privateFunctions = privateFunctions; //do not judge me!
//-------------------- END FUNCTIONS ---------------------------------------------------------------------------

    //-----some helper functions cause I am too lazy to write a long-ass definition each time-----------
    $.fn.ppcommon = $.fn.ppcommon || function (key, value) {
        var commonData = this.data("static-common");
        if (!commonData)
            return value;
        if (typeof value !== "undefined") {
            commonData[key] = value;
            this.data("static-common", commonData);
            return commonData[key];
        } else {
            var result = commonData[key] || null;
            return result;
        }
    }
    //--------------------------------------------------------------------------------------------------

    var init = ($wrapper, skipWindowLoad) => {

        var filtersContainer = $wrapper.find(".search > .filters-container");
        var searchResultsContainer = $wrapper.find(".search-results .inner-wrapper");

        skipWindowLoad = skipWindowLoad || false;

        if (filtersContainer.length == 0 || searchResultsContainer.length == 0) {
            return;
        }
        var isAirBnB = privateFunctions.isAirBnB($wrapper);

        //var switchToMapButton = $wrapper.find(".brandenbutton.switch-to-map");

        var mapLoadedDefer = $.Deferred();

        var sessionFiltersDeferred = null;

        //var justZoomed = false; //@deprecated

        // the Dce Id (cid) and Page Id (pid) for the AirBnB Module
        var cid = $wrapper.data("cid");
        var pid = $wrapper.data("pid");
        var requestType = $wrapper.data('request');

        var moduleData = {
            ajaxRequest: null,
            ignoreAirBnBEvent: true,
            changeMapSection: false,
            supressMapUpdate: false,
            supressSliding: true,
            boundingBox: null,
            isAirBnbOrExternalMap: false
        };

        $wrapper.data("static-common", moduleData);
        $wrapper.ppcommon('isAirBnbOrExternalMap', false);

        if ($wrapper.length) {
            $wrapper.ppcommon('isAirBnbOrExternalMap', true);

            setTimeout(function () {
                privateFunctions.setResultItemHeight($wrapper);
            }, 200);

        }

        var form = filtersContainer.find("form");
        var loaderFunctions = $wrapper.find(".search-results .loader[data-loader]").data("exposed");

        //deferred objects and simmilar-
        var moveEndTimeout = null;
        //------------------------------

        //we load the filters right away
        sessionFiltersDeferred = privateFunctions.loadSessionFilters(sessionFiltersDeferred, cid);

        searchResultsContainer.on("click", ".pagination li > a", function (e) {
            e.preventDefault();
            if ($(this).hasClass("disabled")) return;
            $wrapper.ppcommon("supressSliding", false);
            var url = $(this).attr("href");
            form.attr("action", url);
            form.submit();
        });

        //the search via button is a separate function since we use it on multiple locations
        var triggerSearch = function () {
            $wrapper.find("[name='filters[productcode][]']").each(function () {
                if (!$(this).is('[data-preserve]'))
                    $(this).remove();
            });

            $wrapper.find("[name='filters[external_id][]']").each(function () {
                $(this).remove();
            });

            $wrapper.find("[name='filters[related_to]']").remove();
            $wrapper.find("[data-input-name='filters[price]']").closest(".control.no-icon").removeClass("hide");

            var q = $wrapper.find("input[name='filters[q]']").val();
            if (!!q) {
                privateFunctions.clearDefaultTextValue();
            } else {
                privateFunctions.restoreDefaultValue();
            }
            $wrapper.ppcommon("boundingBox", null);

            //************** trigger tag manager event *********************** */
            var event = "AirBnB:daten";
            var formName = filtersContainer.find(".brandenbutton.search-button").closest("form[name='search']").data("form-name");
            var data = privateFunctions.collectFormData(formName);
            window.pixelpoint.tagManager.event(event, data);

            $wrapper.ppcommon("changeMapSection", true);
            form.attr("action", "");
            form.submit();
        };

        filtersContainer.on("click", ".brandenbutton.search-button", function (e) {
            e.preventDefault();
            triggerSearch();
        });

        window.pixelpoint.pubSub.subscribe(window.pixelpoint.pubSub.events.airBnBSearch, function () {
            triggerSearch();
        });

        form.submit(function (e) {
            e.preventDefault();
            if (privateFunctions.validateForm(true, form)) {
                privateFunctions.submitForm(null, $wrapper);
            }
        });

        var onExternalMapLoad = () => {
            // do everything for mobile
            if ($wrapper.ppcommon('isAirBnbOrExternalMap') && $wrapper.find(".airbnb-change-view-buttons").is(':visible')) {
                followingElementsInContainer($wrapper.find(".airbnb-change-view-buttons"), $wrapper.find('.search-results'));
                privateFunctions.switchToDefaultView($wrapper);

                $wrapper.on("click", ".changeView", function () {
                    changeMapView($wrapper, $(this), false);
                });
                $wrapper.on("click", ".toFilter", function () {
                    scrollToMapFilter($wrapper);
                });
            }
            mapLoadedDefer.done(function () {
                privateFunctions.initialSetBBox($wrapper, sessionFiltersDeferred);
                var map = mapFunctions.mapObject($wrapper);
                if (!!map) {
                    var onSearchTriggered = function (data) {
                        if (!!window.forDebugging)
                            return;

                        if (!data.bbox) {
                            $wrapper.ppcommon("ignoreAirBnBEvent", false);
                            return;
                        }

                        if (!!moveEndTimeout) {
                            clearTimeout(moveEndTimeout);
                        }
                        moveEndTimeout = setTimeout(function () {
                            if (!!$wrapper.ppcommon("ignoreAirBnBEvent")) {
                                $wrapper.ppcommon("ignoreAirBnBEvent", false);
                                return;
                            }
                            $wrapper.ppcommon("boundingBox", data.bbox);
                            privateFunctions.submitForm(() => {
                                let mapObject = mapFunctions.mapObject($wrapper);
                                if(!!mapObject) {
                                    /*
                                    ZP 10.02.2022: we set a timeout to set supressMap to false. I did not want
                                    to do that in the airbnb application since I do not know if there
                                    would be any sideeffects
                                     */
                                    setTimeout(() => {
                                        mapObject.supressSearch = false;
                                    },600);
                                }
                            }, $wrapper);
                        }, 300);
                    }

                    //*
                    const onMapMoveEnd = function (data) {
                        if (mapFunctions.isSearchOnMoveActive($wrapper) && !mapFunctions.isSearchSupressed($wrapper)) {
                            let mapObject = mapFunctions.mapObject($wrapper);
                            if(!!mapObject) {
                                mapObject.fixMapPosition = true;
                            }
                            onSearchTriggered(data);
                        }
                    };
                    map.$off("moveend", onMapMoveEnd).$on("moveend", onMapMoveEnd);
                    const onMapSearchTriggered = function (data) {
                        onSearchTriggered(data);
                    };
                    map.$off("searchtrigerred", onMapSearchTriggered).$on("searchtrigerred", onMapSearchTriggered);
                    //*/
                    const onMapHighlightOver = function (data) {
                        if (!!window.forDebugging)
                            return;
                        if (!$wrapper.find(".airbnb-change-view-buttons").is(':visible')) {
                            var id = data.id || 0;
                            var item = $wrapper.find(`.search-result-item[data-id='${id}']`);
                            item.addClass("map-hover");
                        }
                    };
                    map.$off("highlightover", onMapHighlightOver).$on("highlightover", onMapHighlightOver);
                    const onMapHighlightOut = function (data) {
                        if (!!window.forDebugging)
                            return;
                        $wrapper.find(".search-result-item").removeClass("map-hover");
                    };
                    map.$off("highlightout", onMapHighlightOut).$on("highlightout", onMapHighlightOut);
                    // I removed the find(.search)
                    //$wrapper.find(".search").on("mouseover", ".search-result-item", mouseOverSearchResult);
                    //$wrapper.find(".search").on("mouseout", ".search-result-item", mouseOutSearchResult);
                    $wrapper.on("mouseover", ".search-result-item", function(){
                        var id = $(this).data("id");
                        if (!id) {
                            return;
                        }
                        mapFunctions.mapObject($wrapper).focusItem(id);
                        if (!!mapFunctions.mapObject($wrapper).focusTour)
                            mapFunctions.mapObject($wrapper).focusTour(id);
                    });
                    $wrapper.on("mouseout", ".search-result-item", function(){
                        var id = $(this).data("id");
                        if (!id) {
                            return;
                        }
                        if (!!mapFunctions.mapObject($wrapper).unfocusTour)
                            mapFunctions.mapObject($wrapper).unfocusTour(id);
                    });
                }
            });
            setTimeout(function () {
                privateFunctions.scrollToModule();
            }, 250);

            var map = mapFunctions.mapObject($wrapper);
            if (!!map) {
                //privateFunctions.filtersToAirBnB($wrapper);
                privateFunctions.dataToAirBnB($wrapper);
                privateFunctions.calculateOffset($wrapper);
                mapLoadedDefer.resolve();
            } else {
                window.pixelpoint.map.scriptsLoaded(function () {
                    var element = $(`#${$wrapper.attr("id")} .ppcarto-airbnb`);
                    if (element.length > 0) {
                        if (!$(element).data("ppcarto-airbnb")) {
                            var id = element.attr("id") || null;
                            if (!id) {
                                id = `ppcarto-airbnb-${$wrapper.attr("id")}`;
                                element.attr("id", id);
                            }

                            var ppcartoAirbnb = new Vue({
                                el: `#${id}`
                            });
                            $(`#${id}`).data("ppcarto-airbnb", ppcartoAirbnb);
                        }
                        setTimeout(function () {
                            //privateFunctions.filtersToAirBnB($wrapper);
                            privateFunctions.dataToAirBnB($wrapper);
                            privateFunctions.calculateOffset($wrapper);
                            mapLoadedDefer.resolve();
                        }, 100);
                    }
                });
            }

            //****** we hide the expand button if necessary */
            privateFunctions.checkAndHideExpandButton($wrapper);
            //********************************************* */
        };

        if (!skipWindowLoad) {
            $(window).on("load", onExternalMapLoad);
        } else {
            setTimeout(function () {
                onExternalMapLoad();
            }, 50);
        }

        $(window).on("orientationchange resize", function () {
            if (!!window.forDebugging) {
                return;
            }

            if (privateFunctions.isAirBnB($wrapper)) {
                $wrapper.ppcommon("supressSliding", true);
                privateFunctions.calculateOffset($wrapper);
            }

            // do everything for mobile
            if ($wrapper.ppcommon('isAirBnbOrExternalMap') && $wrapper.find(".airbnb-change-view-buttons").is(':visible')) {
                followingElementsInContainer($wrapper.find(".airbnb-change-view-buttons"), $wrapper.find('.search-results'));
                privateFunctions.switchToDefaultView($wrapper);
            }

            privateFunctions.setResultItemHeight($wrapper);
        });

        $wrapper.on("click", ".einklappen.row-collapse", function () {
            $('.map-wrapper.sticky').foundation('_calc', true);
        });

        //small tag manager snippet******************
        $wrapper.on("click", function (e) {
            var event = "AirBnB:click";
            var data = {
                clickOnMap: false,
                AirBnBFilterClick: false
            };
            var target = $(e.target);
            if (target.closest(".search-wrapper .search").length == 0) {
                data.clickOnMap = true;
            }
            if (target.closest("form[name='search']").length > 0) {
                data.AirBnBFilterClick = target.closest("form[name='search']").data("form-name") || true;
            }
            window.pixelpoint.tagManager.event(event, data);
        });

        //some navigational stuff
        $wrapper.on("click", ".search-result-item a", function (e) {
            if (!!window.sessionStorage) {
                var currentPage = window.location.href;
                window.sessionStorage.setItem(`airBnBKeepPositionOnBack:${currentPage}`, 1);
            }
        });

        //------------------------------------------------------------
        const triggerScriptsLoaded = function () {
            $(".ppcarto-static").each((index, element) => {
                if ($(element).data("ppcarto-static"))
                    return;

                var $element = $(element);
                var id = $element.attr("id");
                if (!id) {
                    id = `ppcarto-static-${index}`;
                    $element.attr("id", id);
                }
                var ppcartoStatic = new Vue({
                    el: `#${id}`
                });
                $(`#${id}`).data("ppcarto-static", ppcartoStatic);
            });
        };
        if (window.ppcartoScriptsLoaded) {
            triggerScriptsLoaded();
        } else {
            window.pixelpoint.map.scriptsLoaded(() => {
                triggerScriptsLoaded();
            });
        }
        //------------------------------------------------------------
    }
    window.externalMap.init = init;

    //-----------------------------------------------------------------------------------------------
    $(".external-map-wrapper").not(".tabbed-external-maps").each(function (index, element) {
        if ($(element).is(":visible")) {
            window.externalMap.init($(element));
        }
    });

    // we take care of the accordions
    if ($(".accordion-with-map").length > 0) {
        $(".accordion-with-map").on("down.zf.accordion", function (event, element) {
            if (!$(element).data("map-initialised")) {
                window.externalMap.init($(element), true);
                $(element).data("map-initialised", "1");
            }

            //ZP 07.02.2022: this is important so that the height gets calculated correctly
            $(element).find('.search-result-item').css({"height":"auto"});

            //we also adjust the heights of the items
            let maxHeight = 0;
            $(element).find('.search-result-item').each((index, el) => {
                let height = $(el).height();
                if (height > maxHeight)
                    maxHeight = height;
            });
            $(element).find('.search-result-item').each((index, el) => {
                $(el).css('cssText', `height:${maxHeight}px !important;`);
            });

            const offsetTop = 77;
            const listHeight = $(element).find(".result-list").height();
            const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0) - offsetTop;
            const heightToSet = listHeight < vh ? listHeight : vh;

            $(element).find(".map-wrapper.map-internal-wrapper").height(
                `${heightToSet}px`
            );
            $(element).find(".map-wrapper.map-internal-wrapper").width(
                $(element).find(".map-parent-container").width()
            );
            $(element).find(".map-parent-container").height(
                `${listHeight}px`
            );
                if (mapFunctions.mapObject($(element)))
                    mapFunctions.mapObject($(element)).map.resize();

                // we make the map sticky
                if(heightToSet < listHeight) {
                    const parentContainer = $(element).find(".map-parent-container");
                    const internalWrapper = $(element).find(".map-wrapper.map-internal-wrapper");
                    $(window).scroll(function () {
                        const topPosition = parentContainer.offset().top - $(window).scrollTop();
                        const bottomPosition =
                            (parentContainer.offset().top + parentContainer.height()) -
                            ($(window).scrollTop() + $(window).height());
                        if (topPosition <= offsetTop) {
                            internalWrapper.addClass("stick");
                        }
                        if (bottomPosition <= 0) {
                            internalWrapper.removeClass("stick").addClass("stick-down");
                        }
                        if (topPosition > offsetTop && bottomPosition > 0) {
                            internalWrapper.removeClass("stick").removeClass("stick-down");
                        }
                    });
                }
                // end
        });
        $(".accordion-with-map").on("click", ".changeView", function(){
           $(this).closest(".accordion-content").find(".search-results").toggleClass("show-map");
            $([document.documentElement, document.body]).animate({
                scrollTop: $(this).closest(".accordion-item").find(".accordion-title").offset().top - 77
            }, 200);
        });
    }
});


function initStickyMapElements($wrapper) {
    var marginInPx = window.externalMap.privateFunctions.getHeaderHeight($wrapper, false); //$('.header-wrapper .header').height();

    // scroll effect on Large Screens
    if (Foundation.MediaQuery.current == "large") {
        var marginInPxNew = $('.header-wrapper .header .main-nav').height();// + 12;
        //var marginInPxNew = $('.header-wrapper .header .main-nav').height() - 2;

        /******************************************************************** */
        /******************************************************************* */
            //we update the damn sticky (I so f*cking hate that thing)
        var stickyPosition = $(".header-wrapper .header").height();

        // scroll effect on Large Screens
        if (Foundation.MediaQuery.current == "large") {
            var stickyPositionNew = $('.header-wrapper .header .main-nav').height() + 12;
            stickyPosition = stickyPositionNew;
        }
        // scroll effect on Large Screens - END
        if ($("#blogHeader .day-section").length > 0) {
            var blogHeaderOffset = $("#blogHeader .day-section").offset();
            var daySectionOffset = $("#blogHeader .day-section").offset().top;
            var scrollOffset = window.pageYOffset + stickyPosition;
            if (daySectionOffset < scrollOffset) {
                $("#blogHeader .day-section .row").foundation('_setSticky');
            }
        }
        //end
        /******************************************************************** */
        /******************************************************************* */

        if (!!$wrapper && $wrapper.closest("#blog-days-container").find("#blogHeader .day-section .row.sticky.is-stuck").length > 0) {
            marginInPxNew += window.externalMap.privateFunctions.getStickyElementHeight($wrapper.closest("#blog-days-container").find("#blogHeader .day-section .row.sticky"), false);//$wrapper.closest("#blog-days-container").find("#blogHeader .day-section .row.sticky").height();
        } else if (!!$wrapper && $wrapper.closest("#blog-days-container").find("#blogHeader .day-section .row.sticky").length > 0) {
            marginInPxNew += window.externalMap.privateFunctions.getStickyElementHeight($wrapper.closest("#blog-days-container").find("#blogHeader .day-section .row.sticky"), false);//$wrapper.closest("#blog-days-container").find("#blogHeader .day-section .row.sticky").height();
        } else {
        }

        marginInPx = marginInPxNew;
    }
    // scroll effect on Large Screens - END

    var marginInEm = marginInPx / parseFloat($("body").css("font-size"));

    var moduleId = "#" + $wrapper.attr("id");
    $(moduleId + ' .sticky').attr('data-margin-top', marginInEm).data('margin-top', marginInEm);

    if ($(moduleId + ' .sticky').attr('data-sticky')) {
        $wrapper.find('.map-wrapper.sticky').foundation('_calc', true);
    } else {
        $(moduleId + ' .sticky').attr('data-sticky', 'true').foundation();
        $(window).trigger("load.zf.sticky");
    }

    if ($("html").hasClass("internet-explorer")) {
        if (!$wrapper.find(".changeView").is(":visible")) {
            var ieSearchWrapperHeight = $(window).height() - marginInPx;

            if (ieSearchWrapperHeight < $wrapper.find(".map-container").height()) {
                ieSearchWrapperHeight = $wrapper.find(".map-container").height();
            }

            $wrapper.find(".search-wrapper").css("max-height", ieSearchWrapperHeight + "px");
        }
    }

    //var ieSearchWrapperHeight = $(window).height() - marginInPx;
    //$(".internet-explorer .external-map-wrapper .search-wrapper, .internet-explorer .global-search .search-wrapper, .internet-explorer .rbnb-wrapper .search-wrapper").css("max-height", ieSearchWrapperHeight+"px");
}


var intervalFollingElementInContainerMap = setInterval(function () {
}, 100);

function followingElementsInContainer($elem, $container) {
    clearInterval(intervalFollingElementInContainerMap);

    var $window = $(window);
    var scrolled = false;
    $window.scroll(function () {
        scrolled = true;
    });

    intervalFollingElementInContainerMap = setInterval(function () {
        if (scrolled) {
            var offset = !!$container && !!$container.offset ? $container.offset() : undefined;
            var outerHeight = !!$container && !!$container.outerHeight ? $container.outerHeight() : 0;
            var containerTop = !!offset && !!offset.top ? offset.top : 0;
            var containerBottom = containerTop + outerHeight;
            var viewportTop = $window.scrollTop();
            var viewportBottom = viewportTop + $window.height();

            if (containerTop < viewportBottom && viewportBottom < containerBottom) {
                $elem.css({
                    opacity: 1,
                    position: 'fixed',
                    bottom: 0
                });
            } else {
                $elem.css({
                    opacity: 1,
                    position: 'absolute',
                    bottom: 0
                });

            }

            scrolled = false;
        }
    }, 100);
}

function changeMapView($wrapper, $button, scrollToFilter) {
    var shownButtonTextClass = '.toMap';
    var hiddenButtonTextClass = '.toList';
    var mapZindex = 10;
    //var resultsZindex = 100;
    var resultsZindex = 20;
    var resultsMaxHeight = 'none';
    var $followElem = $wrapper.find('.search-results');
    var airBnbWrapperHeight = 'auto';
    var $buttonFollowingElem = $wrapper.find('.search-results');

    if ($('.toMap', $button).is(":visible")) {
        shownButtonTextClass = '.toList';
        hiddenButtonTextClass = '.toMap';

        //mapZindex = 101;
        mapZindex = 21;
        resultsZindex = 10;
        resultsMaxHeight = $wrapper.find(".map-container .map-wrapper").height() + 'px';
        $followElem = $wrapper.find(' .map-container .map-wrapper');
        airBnbWrapperHeight = resultsMaxHeight;

        $buttonFollowingElem = $wrapper.find('.search-wrapper');
    }

    $(hiddenButtonTextClass, $button).hide();
    $(shownButtonTextClass, $button).show();

    if ($wrapper.find('.search-wrapper > .map-parent-container').length) {
        $wrapper.find('.search-wrapper > .map-parent-container').css('z-index', mapZindex);
    }

    $wrapper.find(".rbnb-wrapper .map-container .map-wrapper").css('z-index', mapZindex);

    $wrapper.find('.search-wrapper > .search').css({
        'z-index': resultsZindex,
        'max-height': resultsMaxHeight
    });

    $wrapper.find(".rbnb-wrapper").height(airBnbWrapperHeight);

    $button.removeClass("ui-btn-active");

    if (hiddenButtonTextClass == ".toList") {
        window.externalMap.privateFunctions.setResultItemHeight($wrapper);
    }

    //followingElementsInContainer($wrapper.find('.airbnb-buttons'), $buttonFollowingElem);
    followingElementsInContainer($wrapper.find('.airbnb-change-view-buttons'), $buttonFollowingElem);

    if (scrollToFilter) {
        $("html, body").animate({
            scrollTop: $wrapper.find('.search-wrapper').offset().top - window.externalMap.privateFunctions.getHeaderHeight($button, false)
        }, 800);
    } else {
        $("html, body").animate({
            scrollTop: $followElem.offset().top - window.externalMap.privateFunctions.getHeaderHeight($button, false)
        }, 800);
    }
}

function scrollToMapFilter($wrapper) {
    var $searchWrapper = $wrapper.find(".search-wrapper");
    var $buttonElem = $wrapper.find(".changeView");

    if ($('.toMap', $buttonElem).is(":visible")) {
        $("html, body").animate({
            scrollTop: $searchWrapper.offset().top - window.externalMap.privateFunctions.getHeaderHeight($searchWrapper, false)
        }, 800);
    } else if ($('.toList', $buttonElem).is(":visible")) {
        changeMapView($wrapper, $buttonElem, true);
    }
}